import { useEffect, useState } from "react";
import { useIsMounted } from "repoV2/utils/common/render/mount";
import { getParamsFromSearchQuery } from "repoV2/utils/urls&routing/urlParams";

// useCompactStatusForEventPage hook handles the logic for determining if the current displayed in compact mode.
// TODO: @mayank handle this for only for event page URL, have to check its routes
// Currently, after coming back from booking/payment portal we are not getting routes i.e. not able to check
const useCompactStatusForEventPage = () => {
    const [isCompactEventPage, setIsCompactEventPage] = useState<
        boolean | null
    >(false);

    // Custom hook to check if the component is mounted
    const isMounted = useIsMounted();

    useEffect(() => {
        // Check if the component is mounted and if the current page is the event page
        if (isMounted) {
            // Get the current URL
            const url = window?.location.href;
            // Extract the "compact" parameter from the URL
            const params = getParamsFromSearchQuery(url, ["compact"]);

            // Set the compact status based on the extracted parameter
            setIsCompactEventPage(Boolean(params?.compact));
        }
    }, [isMounted]);

    return isCompactEventPage;
};

export default useCompactStatusForEventPage;
